<script setup lang="ts">
import { ArrowUpRight } from '@lucide/vue'
import { useI18n } from 'vue-i18n'
import LogoMark from '@/components/atoms/LogoMark.vue'

const { t } = useI18n()
</script>

<template>
  <footer class="relative overflow-hidden border-t border-line bg-[#070708] pt-20">
    <div class="pointer-events-none absolute -bottom-20 right-0 font-display text-[24vw] font-semibold uppercase leading-none text-outline opacity-30 motion-safe:animate-[float_9s_ease-in-out_infinite]">Spin</div>
    <div class="page-shell relative">
      <div class="grid gap-12 pb-16 md:grid-cols-[1.5fr_1fr_1fr]">
        <div v-reveal class="max-w-sm"><LogoMark class="transition-transform duration-500 hover:rotate-[-6deg] hover:scale-105" /><p class="mt-5 text-lg leading-7 text-zinc-400">{{ t('footer.pitch') }}</p></div>
        <div>
          <p class="mb-4 text-xs font-bold uppercase tracking-[.2em] text-zinc-500">{{ t('footer.explore') }}</p>
          <div class="grid gap-3 text-sm font-semibold">
            <RouterLink to="/games" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('nav.games') }}</RouterLink><RouterLink to="/raffles" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('nav.raffles') }}</RouterLink><RouterLink to="/claim-win" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('nav.claim') }}</RouterLink><RouterLink to="/contact" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('nav.contact') }}</RouterLink>
          </div>
        </div>
        <div>
          <p class="mb-4 text-xs font-bold uppercase tracking-[.2em] text-zinc-500">{{ t('footer.legal') }}</p>
          <div class="grid gap-3 text-sm font-semibold">
            <RouterLink to="/privacy" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('footer.privacy') }}</RouterLink><RouterLink to="/terms" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('footer.terms') }}</RouterLink><RouterLink to="/responsible-gambling" class="w-fit transition-all duration-300 hover:translate-x-1 hover:text-signal">{{ t('footer.responsible') }}</RouterLink>
            <RouterLink to="/admin" class="inline-flex items-center gap-1 text-zinc-600 hover:text-zinc-300">{{ t('nav.admin') }} <ArrowUpRight class="h-3 w-3" /></RouterLink>
          </div>
        </div>
      </div>
      <div class="flex flex-col gap-3 border-t border-line py-6 text-xs text-zinc-600 sm:flex-row sm:items-center sm:justify-between">
        <p>{{ t('footer.copyright', { year: new Date().getFullYear() }) }}</p><p>{{ t('footer.age') }} · {{ t('footer.stakeNote') }}</p>
      </div>
    </div>
  </footer>
</template>
